/** Параметр redirect после авторизации. */
export const REDIRECT_QUERY_PARAM = "redirect";

/** Параметр фильтра списка. */
export const LIST_FILTER_QUERY_PARAM = "flt";

/**
 * Значение для сигнальных query-параметров без полезной нагрузки.
 *
 * @example
 * buildUrl(path, { [OPEN_FILTER_QUERY_PARAM]: QUERY_PARAM_TRIGGER_VALUE })
 */
export const QUERY_PARAM_TRIGGER_VALUE = "1";

/** Параметр открытия модального фильтра (одноразовый trigger). */
export const OPEN_FILTER_QUERY_PARAM = "openFlt";

/** Код отпуска ЛК в query (deep-link с SearchObject и внешней навигации). Значение — `LeaveLimitCard.Code`. */
export const OPEN_LEAVE_CARD_QUERY_PARAM = "leaveCard";

/** @deprecated Legacy: `modal=0` из старого меню; поддерживается через {@link useUrlParamTrigger} на списках. */
export const LEGACY_MODAL_QUERY_PARAM = "modal";
